module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mameve Medwed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Mameve Medwed is also the author of "), _c('I', [_vm._v("Mail, Host Family, The End of an Error,")]), _vm._v(" and "), _c('I', [_vm._v("How Elizabeth Barrett Browning Saved My Life")]), _vm._v(" (which received a 2007 Massachusetts Book Honor Award). Her stories, essays, and reviews have appeared in many publications including the "), _c('I', [_vm._v("Missouri Review, Redbook,")]), _vm._v(" the "), _c('I', [_vm._v("Boston Globe, Yankee,")]), _vm._v(" the"), _c('I', [_vm._v(" Washington Post,")]), _vm._v(" and "), _c('I', [_vm._v("Newsday")]), _vm._v(". Born in Maine, she and her husband have two sons and live in Cambridge, Massachusetts.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QGXyK/tc-custom/9780061860676.jpg?1731793812961",
      "alt": "This image is the cover for the book Of Men and Their Mothers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Of Men and Their Mothers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("All men have mothers . . .")]), _c('p', [_vm._v("It's a truth that the newly unhyphenated Maisie Grey has learned the hard way. After getting rid of her mama's-boy husband, she happily settles down with her teenage son, Tommy. But she's still stuck with the hovering presence of her impossible mother-in-law,  Tommy's grandmother, who refuses to exit the family stage gracefully. ")]), _c('p', [_vm._v("Trying to keep it together with her own business and a new relationship with a man who still lives in—"), _c('i', [_vm._v("where else but?")]), _vm._v("—his mother's house, Maisie struggles to learn from the MIL-from-hell. She vows that when Tommy brings someone home, she'll be loving, empathetic, and supportive. But then along comes completely unsuitable September Silva—with her too-short skirts, black nail polish, and stay-out-all-night attitude—who is forcing Maisie to take a flinty, clear-eyed new look at what it means to be a mother.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0